import { AiDocumentsGroupedByYear, AiMedicalDocumentItem, DocumentsGroupedByYear, MedicalDocumentItem } from '../models/document.interface';

export function formatDocumentsByYear(documents: MedicalDocumentItem[]): DocumentsGroupedByYear {
  const documentsByYear: DocumentsGroupedByYear = {};

  documents.forEach(document => {
    const year = new Date(document.createdAt).getFullYear().toString();
    if (!documentsByYear[year]) {
      documentsByYear[year] = [];
    }
    documentsByYear[year].push(document);
  });

  return documentsByYear;
}

export function sortYearsDescending(a: { key: string }, b: { key: string }): number {
  return parseInt(b.key) - parseInt(a.key);
}

export function formatAiDocumentsByYear(documents: AiMedicalDocumentItem[]): AiDocumentsGroupedByYear {
  const documentsByYear: AiDocumentsGroupedByYear = {};

  documents.forEach(document => {
    const year = new Date(document.documentDate || document.createdAt).getFullYear().toString();
    if (!documentsByYear[year]) {
      documentsByYear[year] = [];
    }
    documentsByYear[year].push(document);
  });

  Object.keys(documentsByYear).forEach(year => {
    documentsByYear[year].sort((a, b) => {
      const dateA = new Date(a.documentDate || a.createdAt);
      const dateB = new Date(b.documentDate || b.createdAt);
      return dateB.getTime() - dateA.getTime();
    });
  });

  return documentsByYear;
}
